<template>
  <div class="monitor-control">
    <div class="monitor-control-search">
      <a-input-search
        @change="handleSearch"
        v-model.trim="searchKeyword"
        placeholder="搜索姓名、电话"
        :allowClear="searchAllowClear"
      >
      </a-input-search>
    </div>
    <ContactModal
      :visible="contactModalVisible"
      :searchData="handleSearchContact"
      :getAllGroup="handleGetAllGroup"
      :getGroupAddress="handleGetGroupAddress"
      @cancel="handleCancelContactModal"
      @add="handleAddAddress"
      @call="handleCallAddress"
      ref="contactModel"
    />
    <SingleInvite
      :visible="singleInviteVisbile"
      :meeting="meeting"
      @cancel="handleCancelSingleInvite"
    />
    <ConfirmModal
      :title="modalConfirm.title"
      :content="modalConfirm.content"
      :visible="modalConfirm.visible"
      :loading="modalConfirm.loading"
      :handleOk="handleModalConfirmOk"
      :handleCancel="handleModalConfirmCancel"
    >
    </ConfirmModal>
    <div class="monitor-control-items">
      <a-dropdown>
        <a-menu slot="overlay">
          <a-menu-item @click="handleSingleInviteButton" key="1">
            手动添加
          </a-menu-item>
          <a-menu-item @click="handleContactInvite" key="3">
            从通讯录添加
          </a-menu-item>
        </a-menu>
        <a-button
          class="monitor-control-button monitor-control-button-normal"
          style="margin-left: 8px"
        >
          <svg-icon class="button-icon" icon-class="invite" />
          <span>邀请入会</span>
        </a-button>
      </a-dropdown>
      <a-button
        class="monitor-control-button monitor-control-button-normal"
        :class="muteButton.class"
        @click="handleMuteButtonClick"
        :disabled="barDisabled"
      >
        <svg-icon class="button-icon" :icon-class="muteButton.icon" />
        <span>{{ muteButton.text }}</span>
      </a-button>
      <a-button
        class="monitor-control-button monitor-control-button-normal"
        :class="recordButton.class"
        @click="handleRecordButtonClick"
        :disabled="recordDisabled"
      >
        <a-icon
          v-if="recordButton.icon === 'sync'"
          type="sync"
          spin
          :style="{ fontSize: '15px' }"
        />
        <svg-icon v-else class="button-icon" :icon-class="recordButton.icon" />
        <span>{{ recordButton.text }}</span>
      </a-button>
      <a-button
        class="monitor-control-button monitor-control-button-normal"
        :class="lockButton.class"
        @click="handleLockButtonClick"
        :disabled="barDisabled"
      >
        <svg-icon class="button-icon" :icon-class="lockButton.icon" />
        <span>{{ lockButton.text }}</span>
      </a-button>
      <a-button
        class="monitor-control-button monitor-control-button-normal"
        :class="waitLineButton.class"
        :disabled="waitLineDisabled"
        @click="handlePlayWaitLineButtonClick"
      >
        <a-icon
          v-if="waitLineButton.icon"
          :type="waitLineButton.icon"
          :spin="waitLineButton.icon === 'sync'"
          :style="{ fontSize: '15px' }"
        />
        <span>{{ waitLineButton.text }}</span>
      </a-button>
      <a-button
        class="monitor-control-button monitor-control-button-normal"
        @click="handleEndButtonClick"
      >
        <svg-icon class="button-icon" icon-class="end" />
        <span>结束会议</span>
      </a-button>
    </div>
  </div>
</template>

<script>
import {
  meetingMute,
  meetingUnMute,
  meetingOnRecord,
  meetingRecordStart,
  meetingNotRecord,
  meetingLock,
  meetingUnLock,
  enableRecordStatus
} from "@/model/conf/model";

import {
  confMuteEnable,
  confMuteDisable,
  confRecordEnable,
  confRecordDisable,
  confLockEnable,
  confLockDisable,
  confClose,
  waitLineEnable,
  waitLineDisable,
  callOutOther,
  addOtherParty,
  queryGroupList,
  queryMoreContactGroup,
  queryContactList,
  queryContactListPage
} from "@/services/conf";

// import { spliceTelNumberKey } from "@/utils/validator";

import ContactModal from "./contact-modal";
import SingleInvite from "./single-invite";

import { throttle } from "lodash";

import ConfirmModal from "@/components/modal/confirm";
import { mapGetters } from "vuex";

// import { buildAcmPhone } from "@/utils/validator";

export default {
  components: {
    ContactModal,
    SingleInvite,
    ConfirmModal
  },
  props: {
    meeting: {
      require: true,
      type: Object
    }
  },
  data() {
    return {
      recordEnableInfo: {
        timeout: undefined,
        enable: false
      },
      contactModalVisible: false,
      batchInviteVisbile: false,
      singleInviteVisbile: false,
      repeatAddressvisible: false,
      confirmModalVisible: true,
      modalConfirm: {
        visible: false,
        loading: false,
        title: "提示",
        content:
          "取消全体静音后整个会场可能会比较this.partyList嘈杂，您确定要继续吗？",
        ok: () => {
          console.log("ok");
        },
        cancel: () => {
          console.log("cancel");
        }
      },
      searchKeyword: "",
      recordFirst: true
    };
  },
  computed: {
    ...mapGetters([
      "chairmanInParty",
      "presenterInParty",
      "dialoutAllowed",
      "recordValid",
      "meetingIsEnd",
      "meetingQaEnable",
      "meetingWaitLineConnect",
      "meetingWaitLineDisable",
      "meetingWaitLineEnable",
      "onlinePartyListInfo",
      "offlinePartyListInfo"
    ]),
    searchAllowClear() {
      // return !isIE();
      return true;
    },
    summit() {
      return this.$store.getters.meetingInfo.bridgeName;
    },
    muteButton() {
      let muteButton = {
        icon: "",
        class: "",
        text: ""
      };
      if (this.meetingIsNotMute()) {
        muteButton.icon = "mute";
        muteButton.text = "全体静音";
      } else if (this.meetingIsOnMute()) {
        muteButton.icon = "unmute";
        muteButton.text = "取消全体静音";
        muteButton.class = "monitor-control-button-enable";
      }
      return muteButton;
    },
    recordButton() {
      const recordButton = {
        icon: "",
        class: "",
        text: ""
      };
      // console.log(this.meeting);

      if (this.meetingIsNotRecord()) {
        recordButton.icon = "record";
        recordButton.text = "开启录音";
      } else if (this.meetingIsOnRecord()) {
        recordButton.icon = "stop-record";
        recordButton.text = "停止录音";
        recordButton.class = "monitor-control-button-enable";
      } else if (this.meetingIsRecordStart()) {
        recordButton.icon = "sync";
        recordButton.text = "连接中";
        recordButton.class = "monitor-control-button-enable";
      }
      return recordButton;
    },
    waitLineButton() {
      const button = {
        icon: "",
        class: "",
        text: ""
      };
      if (this.meetingWaitLineEnable) {
        button.icon = "stop";
        button.text = "停止播放";
        button.class = "monitor-control-button-enable";
      } else if (this.meetingWaitLineDisable) {
        button.icon = "play-circle";
        button.text = "播放等待音";
      } else if (this.meetingWaitLineConnect) {
        button.icon = "sync";
        button.text = "正在连接";
      }
      return button;
    },
    lockButton() {
      const lockButton = {
        icon: "",
        class: "",
        text: ""
      };
      if (this.meetingIsNotLock()) {
        lockButton.icon = "lock";
        lockButton.text = "锁定会场";
      } else if (this.meetingIsOnLock()) {
        lockButton.icon = "unlock";
        lockButton.text = "解除锁定";
        lockButton.class = "monitor-control-button-enable";
      }
      return lockButton;
    },
    barDisabled() {
      return !this.chairmanInParty && !this.presenterInParty;
    },
    waitLineDisabled() {
      return (
        this.meetingIsEnd ||
        this.meetingQaEnable ||
        !this.dialoutAllowed ||
        (!this.chairmanInParty && !this.presenterInParty) ||
        this.meetingWaitLineConnect
      );
    },
    recordDisabled() {
      //return false;
      return (
        this.barDisabled ||
        this.meetingIsRecordStart() === true ||
        !this.enableMeetingRecord()
      );
      //return !this.recordEnableInfo.enable;
    }
  },
  // created() {
  //   setTimeout(() => {
  //     this.recordEnableInfo.enable = false;
  //     // 知道
  //   }, 5000);
  // },
  mounted() {},
  methods: {
    isMeetingFull(number = 0) {
      if (this.meeting.parties === 0) {
        return false;
      } else {
        return this.meetingPartiesNumber() + number > this.meeting.parties;
      }
    },
    handleSearch: throttle(function() {
      this.$store.commit("setSearchKeyword", this.searchKeyword);
    }, 1000),
    meetingRemainNumber() {
      return this.meeting.parties - this.meetingPartiesNumber();
    },
    meetingPartiesNumber() {
      return this.onlinePartyListInfo.length + this.offlinePartyListInfo.length;
    },
    handleModalConfirmOk() {
      this.modalConfirm.ok();
    },
    handleModalConfirmCancel() {
      this.modalConfirm.visible = false;
      this.modalConfirm.cancel();
    },
    handleQuickInvite() {
      this.contactModalVisible = false;
      this.batchInviteVisbile = true;
    },
    handleSingleInviteButton() {
      // 判断是否已满员
      // parties
      if (this.isMeetingFull(1)) {
        // 提示 参会人数已达到预约会议时的最大方数，无法添加
        this.$info({
          title: "提示",
          content: `参会人数量已达到预约会议时设置的最大方数${this.meeting.parties}，无法添加`
        });
      } else {
        this.singleInviteVisbile = true;
      }
    },
    handleBatchInviteButton() {
      this.batchInviteVisbile = true;
    },
    handleInviteButton() {
      this.contactModalVisible = true;
    },
    handleContactInvite() {
      if (this.isMeetingFull(1)) {
        // 提示 参会人数已达到预约会议时的最大方数，无法添加
        this.$info({
          title: "提示",
          content: `参会人数量已达到预约会议时设置的最大方数${this.meeting.parties}，无法添加`
        });
      } else {
        this.contactModalVisible = true;
        this.batchInviteVisbile = false;
      }
    },
    handleSearchContact(searchKey, page, pageSize) {
      return queryContactListPage(searchKey, page, pageSize).then(
        addressList => {
          return {
            addressList
          };
        }
      );
    },
    handleGetAllGroup() {
      return queryGroupList();
    },
    handleGetGroupAddress(groupId, type) {
      if (groupId.length === 1) {
        return queryContactList(groupId[0], type);
      } else {
        return queryMoreContactGroup(groupId);
      }
    },
    handleCancelContactModal() {
      this.contactModalVisible = false;
    },
    handleCancelSingleInvite() {
      this.singleInviteVisbile = false;
    },
    handlePhoneInviteCancel() {
      this.batchInviteVisbile = false;
    },
    handleCallAddress(addressList) {
      if (!this.dialoutAllowed) {
        // 提示没有外呼权限
        this.$info({
          title: "提示",
          // JSX support
          content: <div> 您没有外呼权限 </div>
        });
        this.$refs.contactModel.$emit("contact-model-call-error");
      } else {
        const partyList = this.filterAddAddress(addressList);
        if (partyList) {
          callOutOther(this.summit, partyList)
            .then(() => {
              // partyList.forEach(party => {
              //   const showPhone = buildAcmPhone(
              //     party.countryCode,
              //     party.areaCode,
              //     party.phone
              //   );
              //   party.showPhone = showPhone;
              //   party.status = 2;
              //   party.disconnectReason = 0;
              // });
              // // 前端提前修改成正在连接状态
              // this.$eventHub.$emit("call-out-party", partyList);

              this.$message.success("外呼成功。");
              this.handleCancelContactModal();
            })
            .catch(error => {
              console.log(error);
              this.$message.error("外呼失败。");
              this.$refs.contactModel.$emit("contact-model-call-error");
            });
        }
      }
    },
    handleAddAddress(addressList) {
      const partyList = this.filterAddAddress(addressList);
      if (partyList) {
        addOtherParty(this.summit, partyList)
          .then(() => {
            this.$message.success("添加成功。");
            this.handleCancelContactModal();
          })
          .catch(error => {
            console.log(error);
            this.$message.error("添加失败。");
            this.$refs.contactModel.$emit("contact-model-call-error");
          });
      }
    },
    filterAddAddress(addressList) {
      if (addressList.length > 0) {
        if (this.isMeetingFull(addressList.length)) {
          this.$refs.contactModel.$emit("contact-model-call-error");
          this.$info({
            title: "提示",
            content: `本次添加的参会人数量超过上限，您最多只能再添加${this.meetingRemainNumber()}个参会人`
          });
        } else {
          return addressList;
        }
      } else {
        this.$refs.contactModel.$emit("contact-model-call-error");
      }
    },
    showRepeatAddress(repeatAddressList) {
      const RepeatAddressListHtml = () => {
        const Repeat = repeatAddressList.map(node => {
          return (
            <a-row class="repeat-address-modal-item" type="flex">
              <a-col span="12">
                <span>{node.name}</span>
              </a-col>
              <a-col span="12">
                <span>{node.phone}</span>
              </a-col>
            </a-row>
          );
        });
        return <div class="repeat-address-modal-content">{Repeat}</div>;
      };

      this.$info({
        title: "以下联系人已在会中，无法重复添加。",
        width: "500px",
        // JSX support
        content: (
          <div class="repeat-address-modal">
            <a-row class="repeat-address-modal-title" type="flex">
              <a-col span="12">
                <span>姓名</span>
              </a-col>
              <a-col span="12">
                <span>参会电话</span>
              </a-col>
            </a-row>
            <RepeatAddressListHtml />
          </div>
        )
      });
    },
    meetingIsOnLock() {
      return meetingLock(this.meeting.lockStatus);
    },
    meetingIsNotLock() {
      return meetingUnLock(this.meeting.lockStatus);
    },
    meetingIsNotRecord() {
      return meetingNotRecord(this.meeting.recordStatus);
    },
    meetingIsOnRecord() {
      return meetingOnRecord(this.meeting.recordStatus);
    },
    meetingIsRecordStart() {
      return meetingRecordStart(this.meeting.recordStatus);
    },
    meetingIsOnMute() {
      return meetingMute(this.meeting.muteStatus);
    },
    meetingIsNotMute() {
      return meetingUnMute(this.meeting.muteStatus);
    },
    enableMeetingRecord() {
      const enabled = this.onlinePartyListInfo.some(item =>
        enableRecordStatus(item.status)
      );
      return enabled;
    },
    handleEndButtonClick: throttle(function() {
      this.$confirm({
        title: "提示",
        okText: "确定",
        cancelText: "取消",
        content: () => "确定要结束会议吗?",
        onOk: () => {
          confClose()
            .then(() => {})
            .catch(error => {
              this.$message.error(`结束会议请求失败，请稍后再试。`);
              console.log(error);
            });
        },
        onCancel() {
          console.log("Cancel");
        }
      });
    }, 2000),
    handleLockButtonClick: throttle(function() {
      if (this.meetingIsOnLock()) {
        confLockDisable()
          .then(() => {})
          .catch(error => {
            this.$message.error(`取消锁定会议请求失败，请稍后再试。`);
            console.log(error);
          });
      } else if (this.meetingIsNotLock()) {
        confLockEnable()
          .then(() => {})
          .catch(error => {
            console.log(error);
            this.$message.error(`锁定会议请求失败，请稍后再试。`);
          });
      }
    }, 2000),
    handleMuteButtonClick: throttle(function() {
      if (this.meetingIsOnMute()) {
        this.modalConfirm.content =
          "取消全体静音后整个会场可能会比较嘈杂，您确定要继续吗？";
        this.modalConfirm.ok = () => {
          this.modalConfirm.loading = true;
          confMuteDisable()
            .then(() => {
              this.modalConfirm.visible = false;
              this.modalConfirm.loading = false;
            })
            .catch(error => {
              console.log(error);
              this.$message.error(`取消全体静音请求失败，请稍后再试。`);
              this.modalConfirm.loading = false;
            });
        };
        this.modalConfirm.visible = true;
      } else if (this.meetingIsNotMute()) {
        // 开启静音
        confMuteEnable()
          .then(() => {})
          .catch(error => {
            console.log(error);
            this.$message.error(`全体静音请求失败，请稍后再试。`);
          });
      }
    }, 2000),
    handleRecordButtonClick: throttle(function() {
      // 没有录音权限
      if (!this.recordValid) {
        this.$info({
          title: "提示",
          content: "录音功能已被禁用，您无法使用该功能。"
        });
      } else {
        if (this.meetingIsNotRecord()) {
          // 启动会议录音
          confRecordEnable()
            .then(() => {
              this.recordFirst = false;
            })
            .catch(error => {
              // 解决首次点击录音，有可能失败问题
              if (this.recordFirst) {
                this.recordFirst = false;
                setTimeout(() => {
                  // 尝试5秒后再次开启录音
                  this.handleRecordButtonClick();
                }, 5000);
              } else {
                console.log(error);
                this.$message.error(`开启录音请求失败，请稍后再试。`);
              }
            });
        } else if (this.meetingIsOnRecord()) {
          // 停止会议录音
          confRecordDisable()
            .then(() => {})
            .catch(error => {
              console.log(error);
              this.$message.error(`关闭录音请求失败，请稍后再试。`);
            });
        }
      }
    }, 2000),
    handlePlayWaitLineButtonClick: throttle(function() {
      // playWaitLine();
      if (this.meetingWaitLineEnable) {
        waitLineDisable()
          .then(() => {})
          .catch(error => {
            console.log(error);
            this.$message.error(`停止等待音请求失败，请稍后再试。`);
          });
      } else if (this.meetingWaitLineDisable) {
        waitLineEnable()
          .then(() => {})
          .catch(error => {
            console.log(error);
            this.$message.error(`播放等待音请求失败，请稍后再试。`);
          });
      }
    }, 2000)
  }
};
</script>

<style lang="less">
.button-icon {
  width: 24px !important;
  height: 24px !important;
}
.repeat-address-modal {
  margin-top: 10px;
  .repeat-address-modal-title {
    padding-left: 10px;
    height: 25px;
    line-height: 25px;
    background-color: #f4f4f4;
    border-bottom: 1px solid #e3e7ed;
  }
  .repeat-address-modal-content {
    height: 300px;
    overflow-y: scroll;
    .repeat-address-modal-item {
      padding-left: 10px;
      height: 25px;
      line-height: 25px;
      border-bottom: 1px solid #e3e7ed;
    }
  }
}
.monitor-control {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 40px;
  background-color: #ffffff;
  border: 1px solid #e3e7ed;
  border-radius: 4px;

  margin-bottom: 10px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);

  .monitor-control-search {
    input {
      width: 100px;
      float: right;
      width: 250px;
      text-align: left;
    }
  }
  .monitor-control-items {
    display: flex;
  }
}

.monitor-control-button {
  display: flex;
  align-items: center;
  min-width: 110px;
  height: 32px;
  border-radius: 2px;
  border: solid 1px #e5e5e5;
  background-color: #ffffff;
  font-size: 13px;
  letter-spacing: -0.14px;
  color: #333333;
  cursor: pointer;
  margin-left: 8px;
  span {
    margin-left: 8px;
  }
  &:focus {
    outline: none;
    color: #333333;
    border-color: #e5e5e5;
    /* border: solid 1px #4f8bff;
  letter-spacing: -0.14px;
  color: #4f8bff; */
  }
  &:after {
    border: 0 none;
    opacity: 0;
    animation: none 0 ease 0 1 normal;
  }
  &:hover {
    outline: none;
    border: solid 1px rgba(0, 0, 0, 0.4);
    background-color: rgba(255, 255, 255, 0.8);
    color: #333333;
  }
}
.monitor-control-button-normal {
  &:hover {
    outline: none;
    border: solid 1px rgba(0, 0, 0, 0.4);
    background-color: rgba(255, 255, 255, 0.8);
    color: #333333;
  }

  &:active {
    color: #333333;
    border: solid 1px rgba(0, 0, 0, 0.4);
    background-color: rgba(0, 0, 0, 0.3);
  }
}

// .monitor-control-button:focus {
//   outline: none;
//   color: #333333;
//   border-color: #e5e5e5;
//   /* border: solid 1px #4f8bff;
//   letter-spacing: -0.14px;
//   color: #4f8bff; */
// }
// .monitor-control-button:after {
//   border: 0 none;
//   opacity: 0;
//   animation: none 0 ease 0 1 normal;
// }
// .monitor-control-button-normal:hover {
//   outline: none;
//   border: solid 1px rgba(0, 0, 0, 0.4);
//   background-color: rgba(255, 255, 255, 0.8);
//   color: #333333;
// }

// .monitor-control-button-normal:active {
//   color: #333333;
//   border: solid 1px rgba(0, 0, 0, 0.4);
//   background-color: rgba(0, 0, 0, 0.3);
// }

.monitor-control-button-enable {
  border: solid 1px #4f8bff;
  color: #4f8bff;
  &:focus {
    outline: none;
    border: solid 1px #4f8bff;
    color: #4f8bff;
    /* border: solid 1px #4f8bff;
  letter-spacing: -0.14px;
  color: #4f8bff; */
  }
  &:hover {
    border: solid 1px #4f8bff;
    color: #4f8bff;
    background-color: rgba(89, 139, 255, 0.3);
  }
  &:active {
    border: solid 1px #4f8bff;
    color: #4f8bff;
    background-color: rgba(37, 85, 187, 0.4);
  }
}

// .monitor-control-button-enable:focus {
//   outline: none;
//   border: solid 1px #4f8bff;
//   color: #4f8bff;
//   /* border: solid 1px #4f8bff;
//   letter-spacing: -0.14px;
//   color: #4f8bff; */
// }

// .monitor-control-button-enable:hover {
//   border: solid 1px #4f8bff;
//   color: #4f8bff;
//   background-color: rgba(89, 139, 255, 0.3);
// }

// .monitor-control-button-enable:active {
//   border: solid 1px #4f8bff;
//   color: #4f8bff;
//   background-color: rgba(37, 85, 187, 0.4);
// }
</style>
